<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div id="app">
    <router-view v-if="!merchantExpired" class="router-view" v-slot="{ Component }">
      <transition :name="transitionName">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { showDialog } from 'vant'
import 'vant/es/dialog/style/index'
import axios from '@/utils/axios'
import { parseProductId } from '@/utils/legacy-product-mapping'

  export default {
    setup() {
      const router = useRouter()
      const state = reactive({
        transitionName: 'slide-left',
        merchantExpired: false,
      })
      router.beforeEach((to, from) => {
        if (to.meta.index > from.meta.index) {
          state.transitionName = 'slide-left' // 向左滑动
        } else if (to.meta.index < from.meta.index) {
          // 由次级到主级
          state.transitionName = 'slide-right'
        } else {
          state.transitionName = ''   // 同级无过渡效果
        }
      })

      // 检查商户是否过期（从 URL hash 参数获取 product_id）
      const checkMerchantExpire = async () => {
        try {
          // 使用 parseProductId 统一解析（支持旧版 ?product=N 和新版 ?product_id=uuid）
          // 旧版整数 ID 会被自动映射为对应的 UUID
          const parsed = parseProductId()
          if (!parsed) return

          const res = await axios.get('/common/merchant/check-expire', {
            params: { product_id: parsed.paramValue }
          })
          if (res && res.data && res.data.expired) {
            state.merchantExpired = true
            showDialog({
              title: '服务已到期',
              message: res.data.message || '该商户服务已到期，请联系管理员续费',
              confirmButtonText: '我知道了',
              showCancelButton: false,
              closeOnClickOverlay: false,
            }).then(() => {})
          }
        } catch (e) {
          // 网络异常静默处理，不阻断用户使用
        }
      }

      onMounted(() => {
        checkMerchantExpire()
      })

      return {
        ...toRefs(state)
      }
    }
  }
</script>

<style lang="less">
html, body {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

.router-view{
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: 0 auto;
    -webkit-overflow-scrolling: touch;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active{
    height: 100%;
    will-change: transform;
    transition: all 500ms;
    position: absolute;
    backface-visibility: hidden;
}
.slide-right-enter{
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active{
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-enter{
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active{
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}

.van-badge--fixed {
  z-index: 1000;
}
</style>
